import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check local storage for consent on mount
        const consentStatus = localStorage.getItem('cookie_consent');
        if (!consentStatus) {
            // Show only if no explicit state found
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 2000); // 2-second delay so it doesn't immediately yell at the user
            return () => clearTimeout(timer);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        setIsVisible(false);
    };

    const declineCookies = () => {
        // Just acknowledging that they rejected non-essentials (even though we don't have tracking anyway right now)
        localStorage.setItem('cookie_consent', 'declined');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-banner fade-in-up">
            <div className="cookie-banner-content">
                <div className="cookie-banner-text">
                    <p>
                        <strong>🍪 Une petite douceur ?</strong><br />
                        Nous utilisons des cookies essentiels pour assurer le bon fonctionnement du site (connexion à votre compte, panier, sauvegarde de vos préférences locales).
                        Aucun cookie publicitaire intrusif n'est utilisé. En poursuivant votre navigation, vous acceptez l'utilisation de ces cookies techniques.
                    </p>
                </div>
                <div className="cookie-banner-actions">
                    <button className="cookie-btn cookie-decline" onClick={declineCookies}>Essentiels seuls</button>
                    <button className="cookie-btn cookie-accept" onClick={acceptCookies}>J'accepte</button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
